<template>
  <div
    class="mb-2 flex flex-col rounded-md border border-lk-light-gray p-3 text-gray-700 md:flex-row md:items-center md:p-4"
  >
    <div class="mb-2 flex items-center md:mb-0">
      <div class="mr-3 flex items-center justify-center rounded-full bg-lk-light-purple p-1">
        <TagIcon class="size-5 text-white md:size-6" />
      </div>
      <div class="flex flex-col">
        <p class="text-sm font-medium md:text-base">
          Código: {{ discountCode.code }}
          <span
            class="rounded-full px-2 py-1 text-xs"
            :class="{
              'bg-green-100 text-green-800': isActive,
              'bg-red-100 text-red-800': !isActive,
            }"
          >
            {{ isActive ? 'Activo' : 'Inactivo' }}
          </span>
        </p>
        <p class="text-xs font-medium md:text-sm">{{ discountCode.makerDiscount }}% de descuento</p>
        <p class="text-xs text-gray-500 md:text-sm">
          <span
            v-if="discountCode.onlyOnceByShop"
            class="mr-2"
            >Solo una vez por tienda</span
          >
          <span> Vigente: {{ timeToDate(discountCode.startAt) }} - {{ timeToDate(discountCode.endAt) }} </span>
        </p>
      </div>
    </div>
  </div>
</template>

<script lang="ts" setup>
import { computed } from 'vue';
import { TagIcon } from '@heroicons/vue/24/outline';
import dateTools from './use/date-tools';

const { timeToDate } = dateTools();

const props = defineProps<{
  discountCode: DiscountCode;
}>();

const isActive = computed(() => {
  const now = new Date();
  const startDate = new Date(props.discountCode.startAt);
  const endDate = new Date(props.discountCode.endAt);
  if (now >= startDate && now <= endDate) return true;
  if (props.discountCode.active) return true;
  return false;
});
</script>
